import { render } from "./Home.vue?vue&type=template&id=6461216c&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6461216c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6461216c"

export default script